export default __webpack_public_path__ + "static/media/00.8a163682.jpg";